import {
  DEFAULT_FLAGS,
  FEATURE_FLAG_CLIENT,
  FEATURE_FLAG_KEYS,
  Flags,
} from '@/constants/feature-flag'
import { getCommonsNorthboundAPIs } from '@foreign-clientos/dependency-manager'

async function getClient() {
  return await getCommonsNorthboundAPIs().v1.featureFlags.getClient(
    FEATURE_FLAG_CLIENT,
  )
}

export async function getFlags() {
  try {
    const client = await getClient()
    const flags = await client.getAllFeatureFlags()
    return Object.fromEntries(
      Object.entries(flags).filter(([flagKey]) =>
        Object.values(FEATURE_FLAG_KEYS).includes(
          flagKey as Flags[keyof Flags],
        ),
      ),
    )
  } catch (error) {
    OobeLogger.error('Not able to get feature flags from client', error)
    return DEFAULT_FLAGS
  }
}
